import AcxButton, { IAcxButtonProps } from "components/UI/AcxButton";
import AddIcon from "@mui/icons-material/Add";
import React from "react";
import theme from "Theme/AppTheme";

type AddButtonProps = IAcxButtonProps;

const AddButton: React.FC<AddButtonProps> = ({
    onClick,
    children,
    sx,
    ...rest
}) => {
    return (
        <AcxButton
            startIcon={<AddIcon />}
            onClick={onClick}
            color="white"
            sx={{
                color: theme.palette.primary.main,
                ...sx,
            }}
            {...rest}
        >
            {children}
        </AcxButton>
    );
};

export default AddButton;
